var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('b-container',{staticClass:"main"},[_c('b-row',[_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('Header')],1),_c('b-col',{staticClass:"content-column",attrs:{"md":"8","sm":"12"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }